import { TranslateService } from '@ngx-translate/core';
import { ZoneShape } from 'src/app/classes/viewer/shapes/zone';
import { FromObjectDockingPanel } from 'src/app/classes/viewer/zones/from-object-docking-panel';
import { Model } from 'src/app/interfaces/api/model';
import { PutZone, Zone } from 'src/app/interfaces/api/zone';
import { ZoneService } from 'src/app/services/api/zones/zone.service';
import { Config } from '../../../interfaces/shared/config';
import { ToolsDockingPanel } from './tools.docking-panel';

const Autodesk = window.Autodesk;

export class ZoneDockingPanel extends Autodesk.Viewing.UI.DockingPanel {
    zoneTableId = "1234"
    datatable: any = {
        height: "Height"
    }
    viewer: any;
    zoneTable: HTMLTableElement | null = null;
    zoneTableBody: HTMLTableSectionElement | null = null;
    options: any;
    onCellEditCallback: ((id: string, att: string, value: any) => void) | null = null;
    onDeleteCallback: ((id: string) => void) | null = null;
    zoneService: ZoneService;
    translate: TranslateService;
    zones: ZoneShape[] = [];
    markerTool: any = null;
    mainPanel: any = null;
    toolsPanel: ToolsDockingPanel | null = null;
    selectedTool: any = null;
    colors = Config.colors;

    projectXY: [number, number] | undefined;
    projectLatLonXY: [number, number] | undefined;
    updateZones: (() => void) | undefined;

    offset: { x: number; y: number; z: number };
    origin: any;
    model: Model;
    currentBBox: any;
    currentPolygon: any;
    currentZone: Zone | null = null;
    currentZones: any[] = [];
    fragIds: number[] = [];
    currentBBoxes: any;

    selectedFragIds: number[] = [];
    fromObjectPanel: FromObjectDockingPanel | null = null;

    constructor(viewer: any, container: HTMLElement, id: string, title: string, options: any) {
        super(container, id, title, options);

        this.viewer = viewer;
        this.zoneService = options.zoneService;
        this.translate = options.translate;
        this.zones = options.zones;
        this.model = options.model;
        this.projectXY = options.projectXY;
        this.projectLatLonXY = options.projectLatLonXY;
        this.updateZones = options.updateZones;

        this.selectAllZones = this.selectAllZones.bind(this);
        this.updateZone = this.updateZone.bind(this);
        this.removeZone = this.removeZone.bind(this);

        this.offset = options.offset;
        this.container.style.top = "10px";
        this.container.style.left = "10px";
        this.container.style.width = "600px";
        this.container.style.height = "450px";
        this.container.style.resize = "auto";

        const div = document.createElement('div');
        const div2 = document.createElement('div');

        div2.classList.add('docking-panel-body');
        div.classList.add('docking-panel-container-solid-color-a', 'docking-panel-scroll')
        div.style.height = "calc(100% - 60px)"
        div.style.overflowX = "hidden";
        div.appendChild(div2);

        this.loadAndRenderHtml(div).then(() => {
            this.container.appendChild(div);
            this.zoneTableBody = div.querySelector('#zone-table-body') as HTMLTableSectionElement;
            this.init();
        });
    }

    public init() {
        if (this.fromObjectPanel)
            this.fromObjectPanel.setVisible(false);

        if (this.toolsPanel)
            this.toolsPanel.setVisible(false);

        if (this.zoneTableBody) {
            this.zoneTableBody.innerHTML = "";
        }

        this.zones.forEach((z: ZoneShape) => this.add(z));

        const addZoneObjectBtnOld = document.getElementById("add-zone-object");
        if (addZoneObjectBtnOld) {
            const newBtn = addZoneObjectBtnOld.cloneNode(true) as HTMLElement;
            addZoneObjectBtnOld.parentNode?.replaceChild(newBtn, addZoneObjectBtnOld);
            newBtn.addEventListener('click', () => { this.addZoneObject(); });
        }

        const addZoneBtnOld = document.getElementById("add-zone");
        if (addZoneBtnOld) {
            const newBtn = addZoneBtnOld.cloneNode(true) as HTMLElement;
            addZoneBtnOld.parentNode?.replaceChild(newBtn, addZoneBtnOld);
            newBtn.addEventListener('click', () => { this.addZone(); });
        }

        const selectAllZones = document.getElementById("selectAllZones");
        if (selectAllZones) {
            selectAllZones.removeEventListener('click', this.selectAllZones);
            selectAllZones.addEventListener('click', this.selectAllZones);
        }
    }

    selectAllZones = (event: Event) => {
        const checked = (event.target as HTMLInputElement).checked;
        const zoneCheckbox = document.getElementsByClassName('zone-checkbox') as HTMLCollectionOf<HTMLInputElement>;

        for (let i = 0; i < zoneCheckbox.length; i++) {
            const cell = zoneCheckbox[i];
            if (!cell) continue;

            if (cell.checked !== checked) {
                cell.checked = checked;
                const id = (cell.parentNode?.parentNode as HTMLElement)?.getAttribute('id')?.split("-")[1] || '';
                this.updateZone(id, 'visible', checked);
            }
        }
    }

    add(zone: Zone) {
        const isChecked = zone.visible ? 'checked' : '';
        const row = document.createElement('tr');

        row.classList.add('adsk-searchbox');
        row.id = `row-${zone.id}`;

        row.innerHTML = `
        <td class="zone-visible">
            <input class="edit-zone zone-checkbox" type="checkbox" name="zone-visible" ${isChecked}>
        </td>
        <td class="zone-name">
            <input class="edit-zone form-control input-sm" value="${zone.name}" type="text"/>
        </td>
        <td class="zone-color">
            <input class="edit-zone" type="hidden" value="${zone.color}">
            <div class="color-swatches">
                <span class="color-swatch ${zone.color === 'danger'  ? 'active' : ''}" data-color="danger"  style="background:#dd4b39" title="Red"></span>
                <span class="color-swatch ${zone.color === 'warning' ? 'active' : ''}" data-color="warning" style="background:#FF6600" title="Orange"></span>
                <span class="color-swatch ${zone.color === 'primary' ? 'active' : ''}" data-color="primary" style="background:#3c8dbc" title="Blue"></span>
                <span class="color-swatch ${zone.color === 'success' ? 'active' : ''}" data-color="success" style="background:#00a65a" title="Green"></span>
                <span class="color-swatch ${ (zone.color as string) === 'lemon'   ? 'active' : ''}" data-color="lemon"   style="background:#f3e612" title="Yellow"></span>
                <span class="color-swatch ${ (zone.color as string) === 'teal'    ? 'active' : ''}" data-color="teal"    style="background:#39CCCC" title="Teal"></span>
                <span class="color-swatch ${ (zone.color as string) === 'fuchsia' ? 'active' : ''}" data-color="fuchsia" style="background:#F012BE" title="Fuchsia"></span>
                <span class="color-swatch ${zone.color === 'info'   ? 'active' : ''}" data-color="info"   style="background:#666666" title="Grey"></span>
                <span class="color-swatch ${zone.color === 'dark'   ? 'active' : ''}" data-color="dark"   style="background:#010101" title="Black"></span>
                <span class="color-swatch ${zone.color === 'muted'  ? 'active' : ''}" data-color="muted"  style="background:#808081" title="Muted"></span>
            </div>
        </td>
        <td class="zone-alpha">
            <input class="edit-zone form-control input-sm" value="${zone.alpha}" type="text"/>
        </td>
        <td class="zone-z">
            <input class="edit-zone form-control input-sm" value="${zone.z}" type="text"/>
        </td>
        <td class="zone-height">
            <input class="edit-zone form-control input-sm" value="${zone.height}" type="text"/>
        </td>
        <td>
            <button class="delete-zone btn btn-icon" data-id="${zone.id}" title="${this.translate.instant('form.delete')}">
                <span class="material-icons">delete</span>
            </button>
        </td>
    `;

        this.zoneTableBody?.appendChild(row);

        row.querySelectorAll('.edit-zone').forEach(el => {
            el.addEventListener('change', (e) => this.edit(e));
        });

        row.querySelectorAll('.color-swatch').forEach(swatch => {
            swatch.addEventListener('click', () => {
                const color = (swatch as HTMLElement).getAttribute('data-color')!;
                const hiddenInput = row.querySelector('.zone-color .edit-zone') as HTMLInputElement;
                if (hiddenInput) {
                    hiddenInput.value = color;
                    hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
                row.querySelectorAll('.color-swatch').forEach(s => s.classList.remove('active'));
                swatch.classList.add('active');
            });
        });

        const deleteBtn = row.querySelector('.delete-zone');
        if (deleteBtn) {
            deleteBtn.addEventListener('click', () => {
                this.removeZone(zone.id);
            });
        }
    }

    edit(e: Event) {
        const input = e.target as HTMLInputElement
        const value = input.value;
        const checked = (e.target as HTMLInputElement).checked;

        const id = (input.parentNode?.parentNode as HTMLElement)?.getAttribute('id')?.split("-")[1] || '';
        let updatedValue: any;
        const attrName = (input.parentNode as HTMLElement)?.getAttribute("class")?.split("-")[1] || '';

        switch (attrName) {
            case 'visible':
                updatedValue = checked;
                break;
            case 'z':
            case 'height':
                updatedValue = parseFloat(value)
                break;
            default:
                updatedValue = value;
                break;

        }

        if (attrName != 'id') {
            this.updateZone(id, attrName, updatedValue);
        }
    }

    updateZone = (id: string, att: string, value: any) => {
        if (!this) {
            console.warn('updateZone called with wrong this', this);
            return;
        }

        if (!this.zoneService) {
            console.warn('zoneService is not initialized, cannot update zone', { id, att, value });
            return;
        }

        let zone: PutZone | any = this.zones.find((z: any) => z.id == id);

        if (zone) {
            zone[att] = value;

            zone.draw(true);
            zone.drawGeometry(true);

            let zoneData: PutZone = zone.toJSON();
            this.zoneService.updateZone(zoneData).subscribe(() => { })
        }
    }

    removeZone = (id: string) => {
        let zIndex = this.zones.findIndex((z: any) => z.id == id);

        if (zIndex >= 0) {
            const row = document.getElementById(`row-${id}`);
            if (row && row.parentNode) {
                row.parentNode.removeChild(row);
            }

            this.zones[zIndex]?.remove();
            this.zones.splice(zIndex, 1);
        }

        this.zoneService.removeZone(id).subscribe(() => {
            console.log("zone removed")
        })
    }

    addZoneObject() {
        this.currentBBox = new THREE.Box3();
        this.currentBBoxes = [];
        this.selectedFragIds = [];

        if (this.fromObjectPanel) {
            (this.fromObjectPanel as any).uninitialize?.();
            this.fromObjectPanel = null;
        }

        this.fromObjectPanel = new FromObjectDockingPanel(this.viewer, this.viewer.container, 'zoneFromObjectDockingPanel', 'Zone depuis objet', {
            translate: this.translate,
            zonesService: this.zoneService,
            model: this.model,
            zones: this.zones,
        });

        this.fromObjectPanel.setVisible(true);
    }

    addZone() {
        if (this.toolsPanel) {
            (this.toolsPanel as any).uninitialize?.();
            this.toolsPanel = null;
        }

        this.toolsPanel = new ToolsDockingPanel(this.viewer, this.viewer.container, 'zoneToolsDockingPanel', 'Créer une zone', {
            translate: this.translate,
            zoneService: this.zoneService,
            viewer: this.viewer,
            model: this.model,
            zones: this.zones,
        });

        this.toolsPanel.setVisible(true);
    }

    async loadAndRenderHtml(div: HTMLDivElement) {
        const template = await this.loadHtmlTemplate('viewer/zones/zone-extension/zone-extension.html');
        const variables = {
            viewer_zones: this.translate.instant('viewer.zones'),
            viewer_add_zone: this.translate.instant('viewer.zone.add_drawing'),
            viewer_add_zone_object: this.translate.instant('viewer.zone.add_object'),
            datatable_display: this.translate.instant('datatable.display'),
            datatable_name: this.translate.instant('datatable.name'),
            datatable_color: this.translate.instant('datatable.color'),
            datatable_alpha: this.translate.instant('datatable.alpha'),
            geometry_height: this.translate.instant('geometry.height'),
            datatable_actions: this.translate.instant('datatable.actions'),
        };

        div.innerHTML = this.renderTemplate(template, variables);
    }

    async loadHtmlTemplate(path: string): Promise<string> {
        const response = await fetch(path);
        return await response.text();
    }

    renderTemplate(template: string, variables: Record<string, string | number>) {
        return template.replace(/{{(.*?)}}/g, (_, key) => String(variables[key.trim()] ?? ''));
    }
}